module.exports = __webpack_public_path__ + "img/logo_new.9e18ad1a.png";